import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { chartsTooltipClasses } from "@mui/x-charts";

const HorizontalBarChart = (props) => {
  const [height, setHeight] = useState(315);

  useEffect(() => {
    const updateFontSize = () => {
      if (window.innerWidth >= 2560) {
        setHeight(410);
      } else if (window.innerWidth < 2560 && window.innerWidth >= 2400) {
        setHeight(385);
      } else if (window.innerWidth < 2400 && window.innerWidth >= 2133) {
        setHeight(343);
      } else if (window.innerWidth < 2133 && window.innerWidth >= 1920) {
        setHeight(308);
      } else if (window.innerWidth < 1920 && window.innerWidth >= 1745) {
        setHeight(280);
      } else if (window.innerWidth < 1745 && window.innerWidth >= 1536) {
        setHeight(246);
      } else if (window.innerWidth < 1536 && window.innerWidth >= 1280) {
        setHeight(205);
      } else {
        setHeight(315);
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  const margin = {
    top: height * 0.015,
    right: height * 0.003,
    bottom: height * 0,
    left: height * 0.45,
  };

  return (
    <BarChart
      skipAnimation={false}
      height={height}
      borderRadius={4}
      layout="horizontal"
      grid={{ vertical: true }}
      xAxis={[
        {
          tickLabelStyle: {
            fontSize: "0.625em",
            fontWeight: "700",
            display: "none",
          },
          disableLine: true,
          disableTicks: true,
        },
      ]}
      yAxis={[
        {
          data: props?.ydata,
          scaleType: "band",
          categoryGapRatio: 0.4,
          barGapRatio: 0.6,
          disableTicks: true,
          disableLine: true,
          tickLabelStyle: {
            fontSize: "0.625em",
            fontWeight: "700",
            display: "none",
          },
        },
      ]}
      hideLegend={true}
      margin={margin}
      tooltip={{ trigger: "item" }}
      slotProps={{
        tooltip: {
          sx: {
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.valueCell}`]:
              {
                fontSize: height / 16,
              },
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.labelCell}`]:
              {
                fontSize: height / 18,
              },
          },
        },
      }}
      {...props}
    />
  );
};

export default HorizontalBarChart;
